import { jsx as _jsx } from "react/jsx-runtime";
import { useParams } from "react-router";
import { RoutesList } from "@/router/routesList";
import { useSetPageData } from "@/tools/hooks";
import { ScheduleList } from "./components/ScheduleList";
export var ScheduleTemplatesPage = function () {
    var placeId = useParams().placeId;
    useSetPageData({
        title: "Шаблоны расписаний",
        backLink: RoutesList.Place.getPlaceDetails(placeId),
    });
    return _jsx(ScheduleList, {});
};
